import * as types from '../mutation-types'
import api from '@/http/api'
import {getPromiseAction, getPromiseActionNoMutations} from '@/utils/promiseUtils'

export default {
  namespaced: true,
  state() {
    return {
      user: {},
      permissions: []
    }
  },
  mutations: {
    [types.AUTH_LOGIN](state, body) {
      state.token = body.token;
      state.user = body.user || {};
      state.permissions = body.user.permissions || {};
      localStorage.setItem('token', state.token || '')
    },
    [types.AUTH_CHECK](state, body) {
      state.user = body.user || {};
      state.permissions = body.user.permissions || {};
    },
  },
  actions: {
    postLogin({commit}, payload){
      return getPromiseAction(api.postLogin(payload), commit, types.AUTH_LOGIN)
    },
    getLoginCheck({commit}, payload){
      return getPromiseAction(api.getLoginCheck(payload), commit, types.AUTH_CHECK)
    },
    postPasswordChange({commit}, payload){
      return getPromiseActionNoMutations(api.postPasswordChange(payload))
    },
  }
}



// WEBPACK FOOTER //
// ./src/vuex/auth/index.js